import { render } from "./MapVehicleComponent.vue?vue&type=template&id=45d0ca65"
import script from "./MapVehicleComponent.vue?vue&type=script&lang=js"
export * from "./MapVehicleComponent.vue?vue&type=script&lang=js"
script.render = render

export default script